import { useContext, useMemo } from 'react'
import Logo from '../assets/Footer/FooterLogo.png'
import mail from '../assets/Footer/Mail.svg'
import phone from '../assets/Footer/Phone.svg'
import clock from '../assets/Footer/clock.svg'
import linkedIn from '../assets/Footer/linkedIn.svg'
import instagram from '../assets/Footer/instagram.svg'
import { DataProvider } from '../store/ContextProvider'
import { useNavigate } from 'react-router-dom'

export const Footer = () => {
    const navigate = useNavigate();
    const { currentUser, isAuth } = useContext(DataProvider)
    const navLinks = useMemo(() => ({
        quickLinksOne: [
            { label: "About Us", path: "/about" },
            { label: "Browse Jobs", path: "/login" },
            ...(currentUser?.role === "employer"
                ? [
                    { label: "Post a Job", path: "/create-job" },
                    { label: "Browse Job Seekers", path: "/list-users" },
                    { label: "Pro Search", path: "/pro-search" },
                ]
                : []),
        ],
        quickLinksTwo: [
            { label: "Privacy Policy", path: '/privacy-policy' },
            { label: "Terms and Condition", path: '/terms' },
            ...(isAuth
                ? [{ label: "Get Assistance", path: "/raise-ticket" }]
                : []),
        ],
    }), [currentUser?.role, isAuth]);

    return (
        <footer className="bg-black text-white py-8">
            <div className='px-2 mx-auto max-w-7xl'>
                <div className='flex flex-col  sm:flex-row  sm:justify-between lg:justify-around  flex-wrap my-3 sm:items-center items-stretch'>
                    <img
                        src={Logo}
                        alt="logo"
                        className="h-[100px] w-[150px] md:w-[200px] md:h-[114px]"
                        onClick={() => navigate('/')}
                    />
                    <div>
                        <h3 className='sm:text-[24px] text-[17px] font-semibold sm:mx-20 my-4 sm:my-0'>Quick Links</h3>
                        <div className='flex justify-start md:justify-center gap-5 sm:gap-x-24 sm:my-10 flex-wrap '>
                            <div>
                                <ul className="space-y-5">
                                    {
                                        navLinks.quickLinksOne.map((links, i) =>
                                        (
                                            <li key={i}>
                                                <button
                                                    type='button'
                                                    onClick={() => {
                                                        if (links.path && links.path !== "#") {
                                                            navigate(links.path);
                                                        }
                                                    }}
                                                    className="text-white hover:text-gray-300 transition-colors text-[12px] sm:text-[16px]"
                                                >
                                                    {links.label}
                                                </button>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <div>
                                <ul className="space-y-5">
                                    {navLinks.quickLinksTwo.map((links, i) => (
                                        <li key={i}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (links.path === "#") {
                                                        links.onClick?.();
                                                    } else {
                                                        navigate(links.path);
                                                    }
                                                }}
                                                className="text-white hover:text-gray-300 transition-colors text-[12px] sm:text-[16px]"
                                            >
                                                <span>{links.label}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className='font-semibold mx-0 lg:mx-20 my-4 sm:my-0 sm:text-[24px] text-[17px]'>Contact us</h3>

                        <div className=' sm:my-10 '>
                            <div className='flex justify-start items-center gap-2 my-5 cursor-pointer'>
                                <img src={mail} className='h-4 w-4' alt='Mail' />
                                <p className='text-white text-[12px] sm:text-[16px]'
                                    onClick={() => window.open('mailto:support@careerconnectai.com', '_blank')}>support@careerconnectai.com</p>
                            </div>

                            <div className='flex justify-startitems-center gap-2  my-5 cursor-pointer'>
                                <img src={phone} className='h-4 w-4' alt='Phone' />
                                <p className='text-white text-[12px] sm:text-[16px]' onClick={() => window.open('https://wa.me/6382269679')}>6382269679</p>
                            </div>

                            <div className='flex justify-start items-center gap-2  my-5'>
                                <img src={clock} className='h-4 w-4' alt='Clock' />
                                <p className='text-white text-[12px] sm:text-[16px]'>Mon - Sat: 9.30am - 6.30pm</p>
                            </div>


                            <div className='flex gap-5'>
                                <div className='flex justify-start items-center gap-2  cursor-pointer'>
                                    <img src={linkedIn} className='h-4 w-4' alt='LinkedIn' />
                                    <p className='text-white text-[12px] sm:text-[16px]' onClick={() => window.open('https://www.linkedin.com/company/san-engineering-solutions', '_blank')}>LinkedIn </p>
                                </div>

                                <div className='flex justify-start items-center gap-2 cursor-pointer'>
                                    <img src={instagram} className='h-4 w-4' alt='Instagram' />
                                    <p className='text-white text-[12px] sm:text-[16px]' onClick={() => window.open('https://www.instagram.com/san_group_of_companies?utm_source=qr&igsh=MXQ3NHd1dmFqMW16ZA==', '_blank')}>Instagram </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=' h-[1px] bg-[#d1d1d1]  mx-10 sm:mx-20 md:mx-30 lg:mx-40'> </div>


                <div>
                    <p className='text-[#d1d1d1] text-[10px] sm:text-[14px] my-5 text-center'>All rights reserved © 2025 SAN Engineering solutions</p>
                </div>

            </div>
            {/* {open === "privacy" && (
                <PrivacyPolicyModal isOpen={open} onClose={() => setOpen("")} />
            )}

            {open === "terms" && (
                <TermsCondition isOpen={open} onClose={() => setOpen("")} />
            )} */}
        </footer>
    )
}
